import styled from "styled-components";
import { UnstyledList } from "components/ui/UnstyledList";

export const ListContainer = styled(UnstyledList)`
  overflow-y: auto;

  max-height: 300px;
  width: 100%;
  background: var(--white);
`;
